import React from 'react';
import './Common.css';

interface PaginationProps {
  page: number;
  total: number;
  limit: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ page, total, limit, onPageChange }) => {
  const totalPages = Math.ceil(total / limit);
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, page + 2);
  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <div className="pagination">
      <button className="pagination__btn" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>이전</button>
      {pages.map(p => (
        <button key={p} className={`pagination__btn ${p === page ? 'pagination__btn--active' : ''}`} onClick={() => onPageChange(p)}>{p}</button>
      ))}
      <button className="pagination__btn" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>다음</button>
    </div>
  );
};

export default Pagination;
